module.exports = __webpack_public_path__ + "static/media/8.d973f5f2.jpg";